import Axios from './Base'

const PREFIX = '/_api_'
const ONE_MIN_IN_MS = 1000 * 60

export default class NotificationAlerts {
  constructor(token) {
    this.token = `Bearer ${token.token}`
    this.wedId = token.token_payload.wed_id

    this.axios = Axios({
      cache: true,
      authorization: this.token,
      wedId: this.wedId,
    })
  }

  getNotificationAlerts() {
    return this.axios
      .get(`${PREFIX}/getNotificationAlerts?wed=${this.wedId}`, {
        id: 'notification-alerts',
        cache: {
          ttl: ONE_MIN_IN_MS,
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 400) {
          return []
        }
        throw error
      })
  }

  saveNotificationAlerts(data) {
    return this.axios
      .post(`${PREFIX}/saveNotificationAlerts?wed=${this.wedId}`, data, {
        cache: {
          update: {
            'notification-alerts': 'delete',
          },
        },
      })
      .then((response) => response.data)
  }

  async getNotificationAlertsByType(type) {
    return this.getNotificationAlerts().then((response) => {
      const alerts = response.data
      if (Array.isArray(alerts) && alerts.length) {
        return alerts.filter((alert) => alert.tipo === type)
      }
      return []
    })
  }
}
